var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRoomLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.919 12.621v7.669a.97.97 0 01-.972.97H9.301a.097.097 0 01-.097-.097v-7.669a.97.97 0 01.971-.97h1.646c.054 0 .098.044.098.097z",
    fill: "url(#room_logo_svg__paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.344 1.018v8.975a.097.097 0 01-.097.097H5.59a.97.97 0 01-.972-.97V.145c0-.054.043-.097.097-.097h1.656a.97.97 0 01.972.97z",
    fill: "url(#room_logo_svg__paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.344 17.128v6.899a.97.97 0 01-.972.97H4.716a.097.097 0 01-.097-.098v-6.898a.97.97 0 01.972-.97h1.656c.054 0 .097.043.097.097z",
    fill: "url(#room_logo_svg__paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.717 19.5v4.527a.97.97 0 01-.971.97H.097A.097.097 0 010 24.898v-4.526a.97.97 0 01.972-.97H2.62c.054 0 .097.044.097.098z",
    fill: "url(#room_logo_svg__paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.919 4.758v3.931a.097.097 0 01-.098.097h-1.646a.97.97 0 01-.97-.97V3.886c0-.053.043-.097.096-.097h1.646a.97.97 0 01.972.97z",
    fill: "url(#room_logo_svg__paint4_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.717 1.018v4.527a.097.097 0 01-.097.097H.972A.97.97 0 010 4.672V.145C0 .091.043.048.097.048h1.649a.97.97 0 01.97.97z",
    fill: "url(#room_logo_svg__paint5_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.998 24.903v-6.446c0-.617-.245-1.209-.682-1.645l-2.382-2.377a2.334 2.334 0 00-1.649-.681h-6.457a.097.097 0 00-.098.097v6.445c0 .617.246 1.21.683 1.646l2.382 2.376c.437.437 1.03.682 1.648.682h6.458a.097.097 0 00.098-.097z",
    fill: "url(#room_logo_svg__paint6_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.998.097v6.446c0 .617-.245 1.209-.682 1.645l-2.382 2.377a2.334 2.334 0 01-1.649.681h-6.457a.097.097 0 01-.098-.097V4.704c0-.617.246-1.21.683-1.646L16.795.682A2.333 2.333 0 0118.443 0h6.458c.054 0 .098.044.098.097z",
    fill: "url(#room_logo_svg__paint7_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M102.999 15.247h-7.883v3.09H103v-3.09z",
    fill: "url(#room_logo_svg__paint8_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M119.901.594v3.09h-6.588c-.429 0-.857.019-1.282.088-1.21.267-2.084 1.44-2.175 2.658-.035.639-.03 1.28-.027 1.917h-.004v1.508h8.342v3.09h-8.338c.006 3.938.002 7.873.002 11.809h-3.168c.004-3.844 0-7.687.004-11.534V9.362c.042-1.393-.12-2.809.127-4.19.352-1.86 1.698-3.49 3.46-4.152.818-.336 1.679-.416 2.549-.425h7.098z",
    fill: "url(#room_logo_svg__paint9_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M79.391.884c-.004.933-.004 1.867.002 2.8h-1.716a8.03 8.03 0 00-1.287.088c-1.21.267-2.084 1.44-2.176 2.658-.033.639-.028 1.28-.025 1.917h-.004v1.508h5.206v3.09H74.19c.006 3.938.002 7.872.002 11.808h-3.168c.004-3.843 0-7.686.004-11.533V9.362c.042-1.393-.12-2.81.126-4.19.351-1.86 1.699-3.49 3.46-4.152.885-.362 1.82-.426 2.762-.426h2.016v.012h.002l-.002.278z",
    fill: "url(#room_logo_svg__paint10_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M91.433 24.462v.29h-2.016c-.942 0-1.877-.063-2.762-.425-1.76-.663-3.108-2.293-3.46-4.153-.247-1.38-.084-2.796-.125-4.19v-3.858c-.005-3.846 0-7.69-.005-11.533h3.168l.001 8.392v.87h5.2v3.09h-5.2v2.547h-.007V17h.004c-.002.638-.008 1.279.025 1.918.092 1.218.965 2.391 2.176 2.658.426.07.857.087 1.287.087h1.716c-.006.934-.006 1.868-.002 2.8z",
    fill: "url(#room_logo_svg__paint11_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M142.067 24.754h-4.14l-.243-.458-.902-1.722a136.75 136.75 0 00-.962-1.831c-.909-1.699-1.829-3.387-2.525-5.167a20.127 20.127 0 01-.446-1.258l-.152-.487-.152.487c-.136.426-.285.844-.446 1.258-.695 1.78-1.616 3.468-2.525 5.167-.324.608-.648 1.22-.962 1.831l-.902 1.722-.243.458h-4.14l3.914-6.86 1.035-1.808v-.001c.1-.175.2-.353.3-.532l.046-.082.815-1.425.12-.21c.21-.409.328-.871.328-1.362 0-.51-.128-.99-.353-1.41l-1.114-1.959-2.409-4.237-.853-1.492-1.324-2.326-.261-.457h4.085l.248.457 1.302 2.375.465.844c.613 1.139 1.216 2.29 1.851 3.43.258.471.492.955.709 1.447.11.244.214.49.316.737l.15.37.15-.37c.102-.247.206-.493.316-.737.217-.492.45-.976.709-1.448.635-1.138 1.238-2.29 1.851-3.43l.465-.843 1.302-2.375.248-.457h4.085l-.261.457-1.324 2.326-.853 1.492-2.409 4.237-1.114 1.96c-.225.42-.353.9-.353 1.41 0 .49.118.952.328 1.36l.12.211.814 1.425.047.082c.1.18.2.357.299.532v.001l1.036 1.808 3.914 6.86z",
    fill: "url(#room_logo_svg__paint12_linear)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M56.065 4.35c2.396-.411 5.006-.276 7.17.936 1.731.963 2.879 2.755 3.367 4.656.507 1.862.471 3.807.44 5.719-.067 2.335-.638 4.8-2.242 6.566-1.597 1.767-4.026 2.537-6.348 2.523-2.313.062-4.811-.483-6.491-2.192-1.665-1.659-2.28-4.078-2.407-6.37-.088-2.732-.14-5.64 1.21-8.11 1.046-2.013 3.105-3.35 5.301-3.728zm.9 2.505c-1.16.198-2.254.834-2.915 1.831-.966 1.465-1.182 3.28-1.199 5.001-.01 1.68-.048 3.403.491 5.017.373 1.19 1.133 2.31 2.272 2.864 1.415.67 3.079.722 4.572.3 1.255-.357 2.282-1.333 2.79-2.535.836-1.94.72-4.11.701-6.179-.069-1.81-.386-3.803-1.731-5.122-1.298-1.28-3.274-1.458-4.981-1.177z",
    fill: "url(#room_logo_svg__paint13_linear)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M45.984 20.846c-.482 1.427-1.658 2.524-3.008 3.113-1.813.814-3.865.933-5.814.669-1.75-.254-3.52-1.005-4.653-2.427-.536-.658-.878-1.446-1.09-2.266l-.084-.351-.126-.535h3.102c.373 1.49 1.76 2.472 3.201 2.74 1.58.295 3.364.198 4.713-.772.814-.563 1.275-1.652.938-2.614-.339-.99-1.304-1.558-2.22-1.91-1.843-.693-3.729-1.273-5.566-1.985-1.432-.578-2.812-1.621-3.271-3.174-.491-1.712-.191-3.717 1.017-5.061 1.107-1.242 2.752-1.84 4.36-2.05 2.102-.233 4.378-.028 6.178 1.187 1.075.714 1.84 1.835 2.184 3.08l.086.35.135.546H42.96c-.361-1.127-1.36-1.916-2.474-2.204-1.489-.392-3.203-.357-4.527.511-.796.513-1.238 1.554-.927 2.477.26.822 1.043 1.311 1.796 1.612 1.637.607 3.286 1.171 4.926 1.774 1.332.491 2.651 1.195 3.542 2.34 1.079 1.376 1.235 3.322.688 4.95z",
    fill: "url(#room_logo_svg__paint14_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "room_logo_svg__paint0_linear",
    x1: 8.932,
    y1: 12.553,
    x2: 13.12,
    y2: 20.848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "room_logo_svg__paint1_linear",
    x1: 4.346,
    y1: 0.081,
    x2: 9.531,
    y2: 9.049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "room_logo_svg__paint2_linear",
    x1: 4.346,
    y1: 17.057,
    x2: 7.942,
    y2: 24.899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "room_logo_svg__paint3_linear",
    x1: -0.273,
    y1: 19.422,
    x2: 1.676,
    y2: 25.457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "room_logo_svg__paint4_linear",
    x1: 8.932,
    y1: 3.804,
    x2: 10.52,
    y2: 9.302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "room_logo_svg__paint5_linear",
    x1: -0.273,
    y1: 0.067,
    x2: 1.677,
    y2: 6.102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "room_logo_svg__paint6_linear",
    x1: 12.599,
    y1: 13.79,
    x2: 14.648,
    y2: 26.872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "room_logo_svg__paint7_linear",
    x1: 24.998,
    y1: 0,
    x2: 13.752,
    y2: 11.268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4EBA4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20AD65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "room_logo_svg__paint8_linear",
    x1: 94.325,
    y1: 15.257,
    x2: 94.551,
    y2: 18.926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "room_logo_svg__paint9_linear",
    x1: 105.323,
    y1: 0.673,
    x2: 112.937,
    y2: 27.285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "room_logo_svg__paint10_linear",
    x1: 70.171,
    y1: 0.673,
    x2: 80.981,
    y2: 24.574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "room_logo_svg__paint11_linear",
    x1: 82.213,
    y1: 0.672,
    x2: 93.023,
    y2: 24.573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "room_logo_svg__paint12_linear",
    x1: 121.446,
    y1: 0.672,
    x2: 127.041,
    y2: 28.332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "room_logo_svg__paint13_linear",
    x1: 47.755,
    y1: 4.207,
    x2: 52.135,
    y2: 27.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "room_logo_svg__paint14_linear",
    x1: 29.695,
    y1: 4.206,
    x2: 34.731,
    y2: 27.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })))));
}

export default SvgRoomLogo;